<template>
  <li id='activitybox' class="activity">
    <div class="left">
        <img class="coverImage" :src="activity.ImageUrl" v-on:click="play(activity.ID)">
    </div>
    <div class="right">
      <div class="title">
        {{activity.Title}}
      </div>
      <div v-if="activity.SubTitle!=''" class="subtitle">
        {{activity.SubTitle}}
      </div>
      <div class="time">
        时间:{{activity.BeginTime}}
      </div>
      <div class="address">
        地点:{{activity.Address}}
      </div>
    </div>
      <!-- <div class="cardBox">
          <video v-if="isplay" :id="video.ID" :src="video.VideoUrl"  class="cardCover"/>
          <div v-if="!isplay" class="mask">
              <img src="/images/play.png" class="play" v-on:click="play(video.ID)">
          </div>
          <img v-if="!isplay" :src="video.ImageUrl" class="cardCover">
          <span class="title">{{video.Content}}</span>
      </div> -->
  </li>
</template>
<script>
export default {
  name: "activitybox",
  //data:{},
  props: ["activity"],
  data(){
    return {isplay:false}
  },
  methods: {
      play:function(videoID){
        var t=this;
        t.isplay=true;
        t.$nextTick(function(){
            var video=document.getElementById(videoID);
            if(video.paused){ //如果已暂停则播放
              video.play(); //播放控制
            }else{ // 已播放点击则暂停
              video.pause(); //暂停控制
            }
            video.onended = function() {
                t.isplay=false;
            };
        })
      }
  },
  mounted() {
  }
};
</script>

<style scoped>
.activity{
    height: 240px;
    display: flex;
    flex-direction: row;
    background: #fff;
    padding: 20px;
    margin: 10px 0;
  }
  .activity .left{
    width: 400px;
  }
 .activity .coverImage{
    height: 100%;
    width: 100%;
    border-radius: 5px;
    border: solid 1px #eee;
    -o-object-fit: cover;
    object-fit: cover;
 }
  .activity .right{
    flex: 1;
    padding: 0 20px;
  }
   .activity .title{
    font-size: 22px;
    letter-spacing: 1px;
    font-weight: 600;
    padding: 10px;
    overflow: hidden;
  }
  .activity .subtitle{
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: 500;
    padding: 10px;
    color: #999;
    overflow: hidden;
  }
  .activity .time{
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: 500;
    padding: 10px;
    color: #999;
    overflow: hidden;
  }
  .activity .address{
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: 500;
    padding: 10px;
    color: #999;
    overflow: hidden;
  }
</style>
